// extracted by mini-css-extract-plugin
export default {"item":"Item-module__item__lrKd0"};